import { render, staticRenderFns } from "./UndergradSchool.vue?vue&type=template&id=32aa9249&"
import script from "./UndergradSchool.vue?vue&type=script&lang=js&"
export * from "./UndergradSchool.vue?vue&type=script&lang=js&"
import style0 from "./UndergradSchool.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UndergradSchool.vue"
export default component.exports